/* ========================================================================
 * FD:          FD
 * Child:       USERCONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * user controls
 * top navigation, notification, feedback, app search
 * 
 * Reference:   
 * ======================================================================== 
 * 1/2/2016: creation
 * 6/29/2016: innosuite 2016
*/

FD.SITE = (function ($, me) {
    'use strict';

    var child = me.SITE || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */


    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  get user explorer data
    function getUserExplorerData() {
        var URL = "/Common/Common/GetUserExplorer";

        var options = {
            params: {},
            url: URL,
            ishtml: true,
            callback: afterData          
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $('[data-userexplorer="true"]').html(result);

           // me.setControlLabel();
        }
    }



    //  set default site view
    function setDefaultSiteView() {
        var ELEM = '[data-fd="siteview"]';
        var btn = $(ELEM);

        function updateSiteViewDB(val) {
            var userItem = me.getUserProps();
            var inputProps = {
                GUID: userItem.guid,
                SiteView: val,
                PinState: null
            };

            var URL = "/Common/Common/HandleUserItemFieldCRUD";
            var options = {
                params: inputProps,
                url: URL,
                callback: afterData
            };
            me.AJAX.setAJAX(options);

            //  call view siteview change
            function afterData(data) {
                me.PAGE.getAfterSiteViewChangeEvent(val);
                if ($('.frozen-header-viewport').length > 0) {
                    me.CONTROL.recalculateFrozenTableHeight();
                    me.CONTROL.recalculateScrollTableWidth();
                    // This need to wait for the next screen paint.
                    setTimeout(me.CONTROL.recalculateFrozenTableViewport, 1);
                }
                me.CONTROL.setScrollAfterSiteView({siteView: inputProps.SiteView});
            }
        }


        function setSiteView() {
            var e = $(this);
            var val = e.data().value;

            btn.children('i').removeClass('fa-check-square-o').addClass('fa-square-o');
            e.children('i').removeClass('fa-square-o').addClass('fa-check-square-o');

            $('body').removeClass('cozy').removeClass('compact').removeClass('comfort').addClass(val);

            //  reset page dimension
            me.setPageDimension();

            //  update db
            updateSiteViewDB(val);
        }


        $(document).on('click', ELEM, setSiteView);
    }





    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  default site view
    child.setDefaultSiteView = function () {
        setDefaultSiteView();
    }



    //  get user explorer data
    child.getUserExplorerData = function () {
        getUserExplorerData();
    }

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));

